import { gql } from "gql";

export const GET_ATTACHMENT_FILES = gql(/* GraphQL */ `
  query GetAttachmentsFiles($fileIds: [String]) {
    file(fileIds: $fileIds) {
      id
      link
      fileName
    }
  }
`);
